const nonumber = {
  validate: (input) => {
    return /^[a-zA-Z\u00C0-\u00FF\s,'-]+$/.test(input) && !/^[-',]+$/.test(input)
  },
  message: 'nonumber'
}

const justnumbers = {
  validate: input => {
    return /^[0-9]+$/.test(input)
  },
  message: 'justnumbers'
}

const street = {
  validate: (input) => {
    if (input === undefined || input === null) {
      return
    }
    const firstChars = input.substring(0, 2)
    if (/\d/g.test(firstChars)) {
      input = input.substring(2)
    }
    return /^[a-z\u00C0-\u00FF- ,]+$/i.test(input)
  },
  message: 'street'
}

const city = {
  validate: (input) => {
    if (input === undefined || input === null) {
      return
    }
    const firstChars = input.substring(0, 2)
    if (/\d/g.test(firstChars)) {
      input = input.substring(2)
    }
    return /^[a-zA-Z\u00C0-\u00FF\s,'-]+$/.test(input) && !/^[-',]+$/.test(input)
  },
  message: 'city'
}

const phonenumber = {
  validate: input => {
    return /^((?:\(?(?:00|\+)(?:[1-4]\d\d|[1-9]\d?)\)?)?[-. \\/]?)?((?:\(?\d{1,}\)?[-. \\/]?){0,})(?:[-. \\/]?[-. \\/]?(\d+))?$/.test(input.replace(/\s/g, ''))
  },
  message: 'phonenumber'
}

const flightnumber = {
  validate: input => {
    return /^[0-9]*$/.test(input)
  },
  message: 'flightnumber'
}

const postcodeNL = {
  validate: input => {
    return /^[1-9][0-9]{3} ?[A-Z]{2}$/i.test(input)
  },
  message: 'postcodeNL'
}

const flightCode = {
  validate: input => {
    return /^[A-Z]{2,3} ?[0-9]{1,4}[A-Z]?$/i.test(input)
  },
  message: 'flightCode'
}

const email = {
  validate: input => {
    return /^[\w\-.]+@([\w+-]+\.)+([A-Z]{2,})$/i.test(input)
  },
  message: 'email'
}

const generaltext = {
  validate: input => {
    return /^[\w\u00C0-\u00FF -!?]+$/i.test(input)
  },
  message: 'generaltext'
}

const novalidator = {
  validate: input => {
    return input !== ''
  },
  message: 'novalidator'
}

function bigModulo (inputStr) {
  if (inputStr.length < 10) {
    return parseInt(inputStr, 10) % 97
  }
  let step = inputStr.substr(0, 9)
  let remain = inputStr.substr(9)
  let modResult = parseInt(step, 10) % 97
  while (remain.length > 0) {
    step = modResult.toString() + remain.substr(0, 7)
    remain = remain.substr(7)
    modResult = parseInt(step, 10) % 97
  }
  return modResult
}

const iban = {
  validate: input => {
    const ibString = input.toUpperCase().replace(/\s+/g, '')
    // https://stackoverflow.com/questions/44656264/iban-regex-design
    const reTest = /^([A-Z]{2}[ \\-]?[0-9]{2})(?=(?:[ \\-]?[A-Z0-9]){9,30}$)((?:[ \\-]?[A-Z0-9]{3,5}){2,7})([ \\-]?[A-Z0-9]{1,3})?$/i.test(ibString)
    if (!reTest) {
      return false
    }
    const ctArr = (ibString.substr(4) + ibString.substr(0, 4)).split('')
    const resArr = ctArr.map(c => {
      if (isNaN(c)) {
        return (10 + 'ABCDEFGHIJKLMNOPQRSTUVWXYZ'.indexOf(c)).toString()
      }
      return c
    })
    const resStr = resArr.join('')
    const result = bigModulo(resStr)
    return result === 1
  },
  message: 'IBAN'
}

const validators = [nonumber, justnumbers, phonenumber, postcodeNL, flightCode, email, generaltext, novalidator, flightnumber, iban, street, city]

export {
  nonumber,
  justnumbers,
  phonenumber,
  postcodeNL,
  flightCode,
  email,
  generaltext,
  novalidator,
  flightnumber,
  iban,
  street,
  city,
  validators
}
